

































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import InvertedSpanTooltip from '@/components/commons/InvertedSpanTooltip.vue'
import SpanTooltip from '@/components/commons/SpanTooltip.vue'
import Denuncia from '@/model/Denuncia'
import { showFecha } from '@/utils/DateUtil'
import { ESTADO_DENUNCIA, KEYS_ESTADO_DENUNCIA } from '@/api/StaticApi'

@Component({ components: { SpanTooltip, InvertedSpanTooltip } })
export default class ListadoDenuncias extends Vue {
  mounted() {
    if (!this.disabled) {
      this.headers.push(
        {
          text: 'Estado',
          align: 'center',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          width: '10%',
        }
      )
    } else {
      this.headers.push({
        text: 'Ver más información',
        align: 'center',
        sortable: false,
        width: '10%',
      })
    }
  }

  @Prop()
  private denuncias: Denuncia[]

  @Prop({ type: Boolean, default: false })
  private loading: boolean

  @Prop()
  private pagination: any

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  editItem(item: Denuncia) {
    this.$emit('edit', item)
  }
  deleteItem(item: Denuncia) {
    this.$emit('delete', item)
  }
  viewItem(item: Denuncia) {
    this.$emit('view', item)
  }
  modifyState(item: Denuncia, estado: KEYS_ESTADO_DENUNCIA) {
    this.$emit('modifyState', item, estado)
  }
  showFecha(date: string) {
    return showFecha(date)
  }
  generateExpDesc(item: Denuncia) {
    return `Exp. ${item.expediente.resolucion.numero}/${item.expediente.resolucion.anio} - "${item.expediente.caratula}"`
  }
  generateEstadoDesc(item: Denuncia) {
    return ESTADO_DENUNCIA[item.estado] as string
  }
  esActivo(item: Denuncia) {
    return item.estado === 'ACTIVA'
  }
  esPendiente(item: Denuncia) {
    return item.estado === 'PENDIENTE'
  }

  private localPagination: any = {
    descending: false,
    page: 0,
    rowsPerPage: 5, // -1 for All
  }

  private headers = [
    {
      text: 'Fecha de alta en el registro',
      sortable: false,
      width: '10%',
      align: 'center',
    },
    {
      text: 'Apellido y Nombre del/de la Magistrado/a denunciado/a',
      sortable: false,
      width: '20%',
      align: 'center',
    },
    {
      text: 'Juzgado/Tribunal',
      sortable: false,
      width: '20%',
      align: 'center',
    },
    {
      text: 'Expediente N°/Carátula',
      sortable: false,
      width: '30%',
      align: 'center',
    },
  ]

  @Watch('localPagination')
  paginate(val: any) {
    this.$emit('pagination', val)
  }
}
